import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'

import {
  faCheckSquare,
  faCoffee,
  faPhone,
  faEdit,
  faUserCircle,
  faMapMarkerAlt,
  faEye,
  faEnvelope,
  faClock,
  faSearchPlus,
  faImages,
  faPlus,
  faGlobe,
  faSpinner,
  faUser,
  faBinoculars,
  faTrashAlt,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  fab,
  faChevronLeft,
  faTrashAlt,
  faBinoculars,
  faSpinner,
  faGlobe,
  faEnvelope,
  faCheckSquare,
  faEdit,
  faCoffee,
  faUserCircle,
  faPhone,
  faMapMarkerAlt,
  faEye,
  faClock,
  faSearchPlus,
  faImages,
  faPlus,
  faUser
)
